const formDataAuthor = () => {
  const formData = new FormData();
  formData.append('role', 'Author');
  return formData;
};
export default formDataAuthor;
